module.exports = __webpack_public_path__ + "static/media/pinned.8fb2016d.svg";